import React, { Component, Fragment } from 'react';
import { Modal, Button } from 'react-bootstrap';
import Alerts from '../../components/alerts';

const DEFAULT_TITLE = 'Refresh Project';
const DEFAULT_CLOSE = 'Close';
const DEFAULT_CONFIRM = 'Refresh';

export default class RefreshProjectModal extends Component {
    constructor(props){
        super(props);
        this.state = {
            alerts: [],
            projectId: props.projectId || '',
            isConfirmEnabled: true,
            isActivitiesChecked: true,
            isAllowancesChecked: true,
            isNotesChecked: true,
            isPOsChecked: true,
            isProjectsChecked: true
        }
        //Tests shows warnings if the logic around this var is not present
        this._isMounted = false;
    }

    setProjectId(e){
        this._isMounted && this.setState({
            projectId: e.target.value
        });
    }

    handleConfirmClick = async () => {
        this._isMounted && this.setState({
            isConfirmEnabled: false
        });
        var projectId = this.state.projectId;

        var types = [];
        if(this.state.isActivitiesChecked)
            types.push('Activities');
        if(this.state.isAllowancesChecked)
            types.push('Allowance');
        if(this.state.isNotesChecked)
            types.push('Notes');
        if(this.state.isPOsChecked)
            types.push('PurchaseOrders');
        if(this.state.isProjectsChecked)
            types.push('Project');

        if(!types || types.length === 0) {
            
            this.setState({ 
                alerts: [{type:'danger', msg:'Please select a type'}],
                isConfirmEnabled: true
            });
            return;
        }
        
        await this.props.handleModalClose(true, projectId, types);

        this._isMounted && this.setState({
            isConfirmEnabled: true
        });
    }

    componentWillReceiveProps(props) {
        this._isMounted && this.setState({
            projectId: props.projectId || '',
            isActivitiesChecked: true,
            isAllowancesChecked: true,
            isNotesChecked:true,
            isPOsChecked: true,
            isProjectsChecked: true,
            isConfirmEnabled: true
        });
    }

    componentDidMount(){
		this._isMounted = true;
	}

    componentWillUnmount(){
        this._isMounted = false;
        this.txtRefreshProjectId = null;
    }

    bringModalInputIntoFocus() {
        this.txtRefreshProjectId.focus();
    }

    handleClearAlert = (alert) => {
        var alerts = this.state.alerts || [];
        var alertIndex = alerts.indexOf(alert);
        if(alertIndex > -1)
        {
            alerts.splice(alertIndex, 1);
            this.setState({
                alerts: alerts || []
            });
        }
    }

    render(){
        return (
        <Modal size="lg" show={this.props.isDisplayed} onEntered={() => this.bringModalInputIntoFocus()} onHide={() => this.props.handleModalClose(false)}>
			<Modal.Header closeButton>
				<Modal.Title>{this.props.title || DEFAULT_TITLE}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
                <Fragment>
                    <Alerts alerts={this.state.alerts} handleClearAlert={this.handleClearAlert} />   
                    <div>
                        <label htmlFor="txtRefreshProjectId">Project Id:</label>
                        <input id="txtRefreshProjectId" 
                            tabIndex="1"
                            name="txtRefreshProjectId" 
                            type="text" 
                            className="form-control" 
                            defaultValue={this.state.projectId}
                            ref={(input) => { this.txtRefreshProjectId = input; }}
                            onChange={(e) => this.setProjectId(e)} />
                    </div>
                    <br/>
                    <div>
                        Types:
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <div>
                                <label>
                                    <input type="checkbox" tabIndex="2" value="Activities" checked={this.state.isActivitiesChecked} onChange={() => this.setState({ isActivitiesChecked:!this.state.isActivitiesChecked })} /> Activities
                                </label>
                            </div>
                            <div>
                                <label>
                                    <input type="checkbox" tabIndex="3" value="Allowance" checked={this.state.isAllowancesChecked} onChange={() => this.setState({ isAllowancesChecked:!this.state.isAllowancesChecked })} /> Allowance
                                </label>
                            </div>
                            <div>
                                <label>
                                    <input type="checkbox" tabIndex="4" value="Notes" checked={this.state.isNotesChecked} onChange={() => this.setState({ isNotesChecked:!this.state.isNotesChecked })} /> Notes
                                </label>
                            </div>
                            <div>
                                <label>
                                    <input type="checkbox" tabIndex="5" value="PurchaseOrders" checked={this.state.isPOsChecked} onChange={() => this.setState({ isPOsChecked:!this.state.isPOsChecked })} /> PurchaseOrders
                                </label>
                            </div>

                            <div>
                                <label>
                                    <input type="checkbox" tabIndex="6" value="Project" checked={this.state.isProjectsChecked} onChange={() => this.setState({ isProjectsChecked:!this.state.isProjectsChecked })} /> Project
                                </label>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div>
                        <div className="card">
                            <div className="card-body">
                                <i className="fa fa-info-circle"></i>&nbsp;<span>Project will be refreshed for all the selected types.</span>
                            </div>
                        </div>
                    </div>
                </Fragment>
            </Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" tabIndex="6" onClick={() => this.props.handleModalClose(false,'', [])}>
					{this.props.closeButton || DEFAULT_CLOSE}
				</Button>
                {
                    this.state.isConfirmEnabled === true ?
                    <Button id="btnSubmitRefreshProject" variant="primary" tabIndex="7" onClick={() => this.handleConfirmClick()}>
                        {this.props.confirmButton || DEFAULT_CONFIRM}
                    </Button>
                    : 
                    <Button id="btnDisabledSubmitRefreshProject" disabled={true}>
                        <div className="spinner-border spinner-border-sm text-dark" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        &nbsp;
                        {this.props.confirmButton || DEFAULT_CONFIRM}
                    </Button>
                }
			</Modal.Footer>
		</Modal>
        )
    }
}